import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { clearAllForm, selectTemporary, setForm } from "~/slices/temporarySlice"
import clone from "rfdc/default"

export function useFormStore<T>(key: string, data: any = null) {
  const dispatch = useDispatch()
  const temporary = useSelector(selectTemporary)
  // formUser || clone(authorization.user)
  const [_form, _setForm] = useState<T>((temporary.form || {})[key] || clone(data))

  const setFormData = (data) => {
    _setForm(data)
    dispatch(setForm([key, data]))
  }

  const initSet = (data) => {
    _setForm((temporary.form || {})[key] || clone(data))
  }

  // const clear = () => {
  //   dispatch(clearAllForm())
  // }

  return [_form, setFormData, initSet] as const
}

export function useFormClear() {
  const dispatch = useDispatch()

  const clearForm = (key: string = null) => {
    if (key) {
      dispatch(clearForm(key))
    } else {
      dispatch(clearAllForm())
    }
  }
  return {
    clearForm,
  }
}
